import React from 'react';
import './TempModeDefaults.scss';
import FormTemperatureBox from './FormTemperatureBox';

const TempModeDefaults = ({
  defaultBlockCooling,
  defaultBlockHeating,
  defaultLowerBound,
  defaultUpperBound,
  selectedDefaultBlockCooling,
  selectedDefaultBlockHeating,
  selectedDefaultLowerBound,
  selectedDefaultUpperBound,
  handleChange,
  showMobile,
}) => {
  let convertedMode;

  if (selectedDefaultBlockCooling !== null) {
    if (selectedDefaultBlockCooling === false && selectedDefaultBlockHeating === false) {
      convertedMode = 'auto';
    } else if (selectedDefaultBlockCooling === true && selectedDefaultBlockHeating === true) {
      convertedMode = 'fan';
    } else if (selectedDefaultBlockCooling === true && selectedDefaultBlockHeating === false) {
      convertedMode = 'heat';
    } else if (selectedDefaultBlockCooling === false && selectedDefaultBlockHeating === true) {
      convertedMode = 'cool';
    }
  } else {
    if (defaultBlockCooling === false && defaultBlockHeating === false) {
      convertedMode = 'auto';
    } else if (defaultBlockCooling === true && defaultBlockHeating === true) {
      convertedMode = 'fan';
    } else if (defaultBlockCooling === true && defaultBlockHeating === false) {
      convertedMode = 'heat';
    } else if (defaultBlockCooling === false && defaultBlockHeating === true) {
      convertedMode = 'cool';
    }
  }

  return (
    <div className="default">
      <div className={showMobile ? 'default-container mobile' : 'default-container'}>
        <div className="title">Unoccupied</div>

        <div className="default-items">
          <div className="mode-settings lowerUpperMode-container">
            <div className="bounds-temperatures">
              <FormTemperatureBox
                label="Lower Bound"
                name="lower_bound"
                defaultValue={
                  selectedDefaultLowerBound ? selectedDefaultLowerBound : defaultLowerBound
                }
                updateField={(e) => handleChange(null, 'defaultLowerBound', e)}
              />

              <FormTemperatureBox
                label="Upper Bound"
                name="upper_bound"
                defaultValue={
                  selectedDefaultUpperBound ? selectedDefaultUpperBound : defaultUpperBound
                }
                updateField={(e) => handleChange(null, 'defaultUpperBound', e)}
              />
            </div>

            <div className="mode-container">
              <label>Mode</label>
              <select
                onChange={(e) => handleChange(null, 'defaultMode', e.target.value)}
                defaultValue={convertedMode ? convertedMode : 'auto'}
              >
                <option value="auto">Auto</option>
                <option value="heat">Heat Only</option>
                <option value="cool">Cool Only</option>
                <option value="fan">Fan Only</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TempModeDefaults;
